<template>
    <modal v-model="showModal" @hidden="onHide" size="small">
        <template slot="header">
            <div>
                <h2 class="display-4 montserrat-bold mt-4 mb-0">Download Our Latest App</h2>
            </div>
        </template>
        <div v-if="isAndroid">
            <a :href="links.playStore" @click.prevent="click">
                <img style="width: calc(100%)" :src="links.playStoreImage">
            </a>
        </div>
        <div v-else>
            <a :href="links.appStore" @click.prevent="click">
                <img style="width: calc(100%)" :src="links.appStoreImage">
            </a>
        </div>
    </modal>
</template>
<script>
import mixins from '@utils/mixins';
import { default as config } from "@src/config";

import { isMobile, isAndroid } from 'mobile-device-detect';
import { resource } from "@utils/network";

export default {
    name: 'StoreDownloadModal',

    computed: {
        isAndroid() {
            return isAndroid
        },
    },

    data: () => ({
        links: {
            appStore: config.APP_STORE_LINK,
            playStore: config.PLAY_STORE_LINK,
            playStoreImage: resource("images/dl-google-play.png"),
            appStoreImage: resource("images/dl-app-store.png"),
        },
        showModal: false,
    }),

    methods: {
        click() {
            if (isAndroid) {
                return window.open(this.links.playStore, '_blank');
            }

            return window.open(this.links.appStore, '_blank');
        },
        show() {
            this.showModal = true;
        },

        onHide() {
            this.showModal = false;
        },
    },

    mixins: [ mixins ],

    mounted() {
        if (isMobile) {
            setTimeout(() => this.show(), 1000)
        }
    }
}
</script>